import React from "react";
import "./GuideSection.css";

// "En savoir plus" block displayed below the forms of the order flows
function GuideSection({
  eyebrow = "En savoir plus",
  title,
  intro,
  items,
  note,
}) {
  return (
    <section className="guide-section" aria-label={title}>
      <div className="container">
        <header className="guide-section-header">
          <span className="guide-section-eyebrow">{eyebrow}</span>
          <h2 className="guide-section-title">{title}</h2>
          {intro && <p className="guide-section-intro">{intro}</p>}
        </header>

        <div className="guide-section-grid">
          {items.map(({ icon: Icon, title: itemTitle, text }) => (
            <div key={itemTitle} className="guide-section-card">
              {Icon && (
                <span className="guide-section-icon-wrap" aria-hidden="true">
                  <Icon />
                </span>
              )}
              <h3 className="guide-section-card-title">{itemTitle}</h3>
              <p className="guide-section-card-text">{text}</p>
            </div>
          ))}
        </div>

        {note && <p className="guide-section-note">{note}</p>}
      </div>
    </section>
  );
}

export default GuideSection;
